<template>
  <div class="mx-0 my-0 px-0 py-0">
    <Navbar />
    <div v-if="consultantstatus && consultantstatus.can_do_survey === '0' && consultantstatus.can_do_elearning === '1'">
      <LearningHub />
    </div>
    <div class="mx-auto container-xl">
      <div v-if="consultantstatus && consultantstatus.can_do_survey === '1'">
      <b-card class="surveylist border-0 mb-5">
        <div
          id="my-surveys"
          class="title-area"
        >
          <div class="d-flex justify-content-between">
            <h2 class="title-area">
            {{ screentexts[1]?screentexts[1].element_text:'My Surveys' }}
            </h2>
          <div
              style="float:right;"
              class="vertical-middle text-right"
            >
              <b-link
                to="/create"
                style="text-decoration: none;"
              >
                <b-button
                  id="create-new-survey"
                  block
                  variant="primary"
                  class="btn-responsive mb-2"
                >
                  <span
                    class="icon-plus h4 mr-0 mr-md-2"
                    style="vertical-align: middle"
                    :title="screentexts[3]?screentexts[3].element_text:'Create new survey'"
                  />
                  <span
                    class="d-none d-sm-none d-md-inline-block"
                  >
                    {{ screentexts[3]?screentexts[3].element_text:'Create new survey' }}&nbsp;
                  </span>
                </b-button>
              </b-link>
              <!-- PopupBubble
                v-if="screentexts[3] && screentexts[3].element_bubbletext != '' && screentexts[3].element_bubbletext !== null"
                element_id="create-new-survey"
                :screen_id="screen_id"
                screenelement_id="3"
                :bubbletext="screentexts[3]?screentexts[3].element_bubbletext:''"
              /-->
              <!-- br -->
              <b-link
                to="/aggregatedreports"
                style="text-decoration: none;"
              >
                <b-button
                  id="aggregated-reports"
                  block
                  variant="secondary"
                  class="btn-responsive"
                >
                  <span
                    class="icon-plus h4 mr-0 mr-md-2"
                    style="vertical-align: middle;"
                    title="Aggregated reports"
                  />
                  <span
                    class="d-none d-sm-none d-md-inline-block"
                  >
                    {{ 'Aggregated reports' }}
                  </span>
                </b-button>
              </b-link>
              <!-- PopupBubble
                v-if="profile.aggregated_reports==='1'"
                element_id="aggregated-reports"
                :screen_id="screen_id"
                screenelement_id="3"
                :bubbletext="screentexts[3]?screentexts[3].element_bubbletext:''"
              /-->
            </div>
          </div>
        </div>
        <br>
        <b-tabs
          v-model="tabIndex"
          class="mt-4"
          content-class="mt-0"
          nav-class="flex-column flex-sm-column flex-md-column flex-lg-row flex-xl-row"
        >
          <b-tab>
            <template v-slot:title>
              <fa-icon
                name="rocket"
                class="mr-1"
              />{{ screentexts[149]?screentexts[149].element_text:'Ongoing' }} <b-badge
                class="mute"
              >
                {{ surveycount_3 }}
              </b-badge>
            </template>
            <Surveys
              v-if="tabIndex==0"
              surveytype="ongoing"
            />
          </b-tab>
          <b-tab lazy>
            <template v-slot:title>
              <fa-icon
                name="pen"
                class="mr-1"
              />{{ screentexts[150]?screentexts[150].element_text:'Drafts' }} <b-badge variant="info">
                {{ surveycount_1 }}
              </b-badge>
            </template>
            <Surveys
              v-if="tabIndex==1"
              surveytype="drafts"
            />
          </b-tab>
          <b-tab lazy>
            <template v-slot:title>
              <fa-icon
                name="clock"
                class="mr-1"
              />{{ screentexts[151]?screentexts[151].element_text:'Upcoming' }} <b-badge variant="info">
                {{ surveycount_2 }}
              </b-badge>
            </template>
            <Surveys
              v-if="tabIndex==2"
              surveytype="upcoming"
            />
          </b-tab>
          <b-tab lazy>
            <template v-slot:title>
              <fa-icon
                name="check"
                class="mr-1"
              />{{ screentexts[152]?screentexts[152].element_text:'Finished' }} <b-badge variant="info">
                {{ surveycount_4 }}
              </b-badge>
            </template>
            <Surveys
              v-if="tabIndex==3"
              surveytype="finished"
            />
          </b-tab>
          <b-tab lazy>
            <template v-slot:title>
              <fa-icon
                name="trash-alt"
                class="mr-1"
              />{{ screentexts[153]?screentexts[153].element_text:'Deleted' }}
            </template>
            <Surveys
              v-if="tabIndex==4"
              surveytype="deleted"
            />
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <div
      v-if="consultantstatus && consultantstatus.can_do_survey === '1'"
      id="my-folders"
    >
      <Folders />
    </div>
    <div
      v-if="consultantstatus && consultantstatus.can_do_survey === '1'"
      id="my-aggregatedreports"
    >
      <MyAggregatedReports />
    </div>
    <b-card class="surveylist border-0">
      Last login: {{ user.prev_login }}
    </b-card>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Surveys from './Surveys.vue'
import Folders from './Folders.vue'
// import PopupBubble from './PopupBubble'
import MyAggregatedReports from './MyAggregatedReports.vue'
import LearningHub from './LearningHub.vue'

export default {
  name: 'MyGDQPage',
  components: {
    Navbar,
    Surveys,
    Folders,
    // PopupBubble,
    MyAggregatedReports,
    LearningHub
  },
  data: function () {
    return {
      screen_id: 1,
      screentexts: [],
      profile: this.$store.state.profile,
      user: this.$store.state.user,
      tabIndex: 0,
      thisurl: window.location.href,
      surveycount_1: 0,
      surveycount_2: 0,
      surveycount_3: 0,
      surveycount_4: 0
    }
  },
  computed: {
    promptupdate: function () {
      return true
    },
    consultantstatus: function () {
      const consultantstatus = this.$store.state.consultantstatuses.find(s => s.id === this.profile.consultantstatus_id)
      if (consultantstatus) {
        const beh = consultantstatus
      }
      return consultantstatus
    }
  },
  created () {
    this.user_usergroups_get()
    this.countries_get()
    this.consultantstatuses_get()
    this.formoptions_get()
    this.screentexts_get()
    this.$store.dispatch('group_clear')
    this.$store.dispatch('survey_clear')
    this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: 0 })
    this.surveycounts_get()
  },
  methods: {
    async surveycounts_get () {
      const filter = { survey_deleted: { operator: '=', value: 0, realfield: 1 } }
      this.surveycount_1 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 1, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_2 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 2, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_3 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 3, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
      this.surveycount_4 = await this.$store.dispatch('surveys_fetch', {
        filter: { ...filter, survey_status_id: { operator: '=', value: 4, realfield: 1 } },
        countonly: 1
      }).then(r => { return r.data.total })
    },
    user_usergroups_get () {
      this.$store.dispatch('user_usergroups_fetch')
        .then((resp) => {
          return resp
        })
    },
    countries_get () {
      this.$store.dispatch('countries_fetch')
    },
    consultantstatuses_get () {
      this.$store.dispatch('consultantstatuses_fetch')
    },
    formoptions_get: function () {
      this.$store.dispatch('formoptions_fetch')
    },
    screentexts_get: function () {
      var screentexts = []
      var filter = {
        screen_id: {
          operator: '=',
          value: this.screen_id
        }
      }
      this.$store.dispatch('systemscreenelements_fetch', { filter: filter })
        .then((resp) => {
          var dbtexts = resp.data.result
          for (var i = 0; i < dbtexts.length; i++) {
            var screentext = {
              id: dbtexts[i].id,
              element_text: dbtexts[i].element_text,
              element_bubbletext: dbtexts[i].element_bubbletext
            }
            screentexts[dbtexts[i].id] = screentext
          }
          this.screentexts = screentexts
        })
    }
  }
}
</script>
<style scoped>
.surveylist {
  min-height: 340px;
}
</style>
